import {AbstractFormControlValueAccessor} from '@shared/modules/form/common/abstracts/abstract-form-control-value-accessor';
import { Input, Directive } from '@angular/core';
import {UntypedFormControl, NgControl} from '@angular/forms';
import {FormFields} from '@shared/modules/form/interfaces';

@Directive()
export abstract class AbstractControl extends AbstractFormControlValueAccessor {
  @Input() config: FormFields;

  protected constructor(public ngControl: NgControl) {
    super(ngControl);
  }

  onChange(value: any): void {
    this.value = value;
    this._onChange(value);
    this.setControlStatus();
  }

  onBlur(): void {
    this._onTouch();
    this.setControlStatus();
  }

  setControlAsEnabled(): void {
    if (this.config.isFormControlEnabledForce || !this.config.isFormControlDisabled) {
      this.formControl.enable();
    }
  }

  setControlAsDisabled(): void {
    if (!this.config.isFormControlEnabledForce && (!this.config.required || this.config.isFormControlDisabled)) {
      this.formControl.disable();
    }
  }

  setControlStatus(): void {
    // W przypadku gdy kontrolka NIE jest wymagana i nie ma wartości, jest ona wyłączona - nie dodaje się do formGroupy.
    // Jeśli jest flaga `isFormControlEnabledForce`, to wymusza ona, aby kontrolka była zawsze włączona (dodana do formGroupy).

    if (this.config.isFormControlEnabledForce || (!!this.formControl.value && !this.config.isFormControlDisabled)) {
      this.setControlAsEnabled();
    } else {
      this.setControlAsDisabled();
    }
  }

  get formControl(): UntypedFormControl {
    return this.ngControl.control as UntypedFormControl;
  }
}
